import React, {Fragment} from "react";
import {Button, Col, Form, Modal, Row, Input, Radio, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import ImagePicker from '@components/custom/imagePicker';
import {Image} from "@models/poster";
import {VideoFile} from "@models/video-file";
import VideoFilesSelection from "@components/video-files/Selection"
import {SelectionMode} from "@models";

interface PropsShape {
  item: VideoFile | null;
  form: any;
  index: number;
  onEdit: any;
  onAdd: any;
  visible: boolean;
  poster: Image;
  id: string | null;
}

class ItemForm extends React.Component<PropsShape> {
  constructor(props) {
    super(props);
    const {item={}} = this.props;
    this.state = {
      visible: false,
      video_file_type: item.video_file_type ? item.video_file_type : "primary",
      poster: item.poster ? item.poster : null,
      video_content_id:  item.video_content ? item.video_content.id : null,
      video_file : item.video_file ? item.video_file : null,
      id: item.id ? item.id : null
    };
  }
  
  handleSubmit = () => {
    this.props.form.setFieldsValue({
      "poster_id": this.state.poster ? this.state.poster.id : "",
      "video_file_id": this.state.video_file ? this.state.video_file.id : ""
    });
    
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = {
          video_file_type: this.state.video_file_type,
          poster: this.state.poster ? this.state.poster : null,
          poster_id : this.state.poster.id,
          video_file_id: this.state.video_file.id,
          video_file: this.state.video_file ? this.state.video_file : null,
          id: this.state.id ? this.state.id : null,
          ...values
        };
        
        if (this.props.item) {
          this.props.onEdit(this.props.index, data);
        }
        else {
          this.props.onAdd(data);
        }
        
        this.setState({
          ...data,
          visible: false
        })
      }
    });
  };
  
  showModal = () => {
    this.setState({
      visible: true
    });
  };
  
  hideModal = () => {
    this.setState({
      visible: false
    });
  };
  setImage = (poster: Image) => {
    this.setState({
      poster: poster,
    })
  };
  
  setPrimaryFile = (e) => {
    this.setState({
      video_file_type: e.target.value
    });
  };
  
  visableView() {
    let {item, key, index, id, moveCard, onDelete} = this.props;
    if (!item) {
      return (
        <Button type="link" onClick={() => this.showModal(false)}>
          <FormattedMessage id="app.add_file" defaultMessage={`Add File`}/>
          <Icon type="plus"/>
        </Button>
      );
    }
    else{
      const poster = item.poster || {};
      return(
        <div className={`video-file-item image-box-wrapper`}>
          <div
            className={`image-box`}
            style={{backgroundImage: `url(${poster.path})`}}>
            <div className={`image-hover-box`}>
              <div className={'image-actions-wrapper'}>
                <Icon type="edit" onClick={(e) => {
                  e.preventDefault();
                  this.showModal(true)
                }}/>
                <Icon type="delete" onClick={() => onDelete(index)}/>
              </div>
              {/*<div className="image-box-bottom">*/}
                {/*<span className={`image-title`}>{item.title || image_file.title}</span>*/}
              {/*</div>*/}
            </div>
          </div>
        </div>
      )
    }
  }
  
  setFile = (video_file:VideoFile) =>{
    this.setState({
      video_file
    })
  };
  
  render() {
    const {form} = this.props;
    const {getFieldDecorator} = form;
    return (
      <Fragment>
        {this.visableView()}
        <Modal
          className="form-modal"
          visible={this.state.visible}
          destroyOnClose={true}
          closable={false}
          maskClosable={false}
          mask={true}
          footer={[
            <Button key="back" onClick={() => this.hideModal()}>
              <FormattedMessage id="app.cancel" defaultMessage={`Cancel`}/>
            </Button>,
            <Button key="submit" type="primary" onClick={() => this.handleSubmit()}>
              <FormattedMessage id="app.save" defaultMessage={`Save`}/>
            </Button>
          ]}>
          <div className={'form-wrapper'}>
            <Form>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item className={'no-label'}>
                    {getFieldDecorator("video_file_id", {
                      rules: [{
                        required: true,
                        message: <FormattedMessage id="app.poster_is_required"
                                                   defaultMessage={`Poster is required!`}/>
                      }]
                    })(
                      <ImagePicker onSelectImage={this.setImage} selectedImage={this.state.poster}>
                        <div className={`image-wrapper`} style={{backgroundImage: `url(${this.state.poster ? this.state.poster.path : ""})`}}>
                          <FormattedMessage id="app.select_poster_image" defaultMessage={`Select poster image`}/>
                        </div>
                      </ImagePicker>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label={<FormattedMessage id="app.video_file" defaultMessage={`Video File`}/>}>
                    {getFieldDecorator("video_file_id", {
                      initialValue: this.state.video_file ? this.state.video_file.id : null,
                      rules: [{
                        required: true,
                        message: <FormattedMessage id="app.file_is_required"
                                                   defaultMessage={`File is required!`}/>
                      }]
                    })(<Input type={"hidden"}/>)}
                    <VideoFilesSelection mode={SelectionMode.DEFAULT}
                                         disabled={this.state.id ? true : false}
                                         initialValue={this.state.video_file}
                                         onChange={this.setFile}/>
                  </Form.Item>
                </Col>
                
                <Col span={24}>
                  <Form.Item label={<FormattedMessage id="app.primary_file" defaultMessage={`video_file_type`}/>}>
                    <Radio.Group value={this.state.video_file_type} onChange={this.setPrimaryFile}>
                      <Radio value="primary">اصلی (primary)</Radio>
                      <Radio value="trailer">تربلر (trailer)</Radio>
                      <Radio value="teaser">تیزر (teaser)</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default Form.create({name: "file-item-form"})(ItemForm);
